export default __webpack_public_path__ + "static/media/b3-logo-white.19776928.svg";